import type { TextProps } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';
import { FormatPrice } from 'components/localisation/FormatPrice';
import type { Money } from 'types/product/Money';
import { getSavingsRate } from 'utils/getSavingsRate';

interface ProductPriceSavingProps extends TextProps {
  compareAtPrice?: Money | null;
  price: Money;
  showAsAmount?: boolean;
}

const textProps = {
  className: 'price--saved',
  as: 'span',
  size: 'detail',
  color: 'red.300',
  fontWeight: 'medium',
  whiteSpace: 'nowrap',
} as const;

export function ProductPriceSaving({
  compareAtPrice,
  price,
  showAsAmount,
  ...props
}: ProductPriceSavingProps) {
  if (!compareAtPrice) return null;
  if (compareAtPrice.amount - price.amount === 0) return null;

  if (showAsAmount) {
    return (
      <FormatPrice
        amount={compareAtPrice.amount - price.amount}
        beforeText="Save "
        {...textProps}
        {...props}
      />
    );
  }

  const percentageSaving = getSavingsRate({
    anchor: compareAtPrice.amount,
    price: price.amount,
  });

  return (
    <Text {...textProps} {...props}>
      Save {percentageSaving}%
    </Text>
  );
}
